import React from "react";
import Container from "@/components/marketing/Container";
import SectionHeading from "@/components/marketing/SectionHeading";
import { useOutletRecords } from "@/hooks/useOutletRecords";

// Named key regional sites. Logos are read live from the catalogue where a
// product record exists; names without a record render as a text fallback.
const SITES = ["Zawya", "MENA FN", "Business Arabia"];

export default function GulfNewswireCoverage() {
  const records = useOutletRecords(SITES);

  return (
    <section className="py-12 lg:py-16 bg-canvas">
      <Container>
        <SectionHeading
          tag="COVERAGE"
          title="80 pickups. The whole Gulf."
          subtitle="Your press release is distributed across mainstream media in the United Arab Emirates, Saudi Arabia, Qatar, Kuwait, Bahrain, and Oman, reaching over 5,000 journalists and delivering 80 media pickups, 40 in English and 40 in Arabic."
        />

        <div className="mt-10 text-center">
          <p className="text-sm text-steel mb-5">Including guaranteed placement on:</p>
          <div className="flex flex-wrap items-center justify-center gap-8 lg:gap-12">
            {SITES.map((name) => {
              const rec = records[name];
              const logo = rec && rec.brand_logo_url;
              return logo ? (
                <img
                  key={name}
                  src={logo}
                  alt={name}
                  className="h-8 max-w-[120px] w-auto object-contain opacity-70"
                />
              ) : (
                <span key={name} className="font-heading text-base font-bold text-steel">
                  {name}
                </span>
              );
            })}
          </div>
        </div>
      </Container>
    </section>
  );
}